import React from 'react';
import { Button, Link, Step, StepLabel, Stepper, Typography } from '@mui/material';
import WebIcon from '@mui/icons-material/Language';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
import { GETTING_STARTED } from '../../utils/constants';

export const StepperComponent = ({step, labels}) => {
	return(
			<Stepper  activeStep={step} alternativeLabel>
			{
				labels.map((label) => (
					<Step key={label}>
						<StepLabel StepIconProps={{
                            sx: {
                                '&.Mui-active': {
                                    color: 'var(--theme-pink)', // Color when step is active
                                },
                                '&.Mui-completed': {
                                    color: 'var(--theme-pink)', // Color when step is completed
                                },
                                color: 'var(--theme-pink)'}
                        }}>{label}</StepLabel>
					</Step>
				))
			}
			</Stepper>
	)
}

const GetStartedComponent = ({steps}) => {
    const queryParams = new URLSearchParams(window.location.search)
    const entity = queryParams.get('entity');

    const decodedEntity = JSON.parse(atob(decodeURIComponent(entity)));
    const redirectToPage = () => {
        window.location.replace(GETTING_STARTED)
    } 

    return(
        <div className='dis-flex flex-column flex-grow-4 form-component'>
            <StepperComponent step={2} labels={steps} />
            <div className='dis-flex flex-row m-t-40 font-30 text-bold'>
                Success!
            </div>
            <div className='dis-flex flex-row m-t-10'>
                <div >
                    We have sent a text message to your mobile number with your secret Game Key and a link to download ‘Lumi Nova’ from the App Stores.
                </div>
            </div>
            <div className='dis-flex flex-row m-t-40 font-20 text-bold'>
                Next Steps
            </div>
            <div className='dis-flex flex-row m-t-10'>
                <div >
                Click the link below to learn more about getting started with Lumi Nova.
                </div>
            </div>
            <div className='dis-flex m-t-10'>
                <Button style={{background:'var(--theme-pink)', padding: '10px 50px', textTransform: 'none'}} variant='contained' onClick={redirectToPage} fullWidth={false}><b>Getting Started</b></Button>
            </div>
            <div className='dis-flex flex-row m-t-40 font-20 text-bold'>
                Support
            </div>

            <div className='dis-flex flex-row m-t-10' >
                <div className='dis-flex flex-column'>
                    Lumi Nova has been provided to you in partnership with {decodedEntity.entity_name}.
                </div>
            </div>
            <div className='dis-flex flex-row m-t-40 text-bold'>
                <div >
                    For more information or support please contact:
                </div>
            </div>
            <div className='dis-flex flex-row m-t-10'/>
            {decodedEntity.email && <div className='dis-flex flex-row'>
                <EmailIcon />
                <Typography className='p-l-6'>
                    <Link color={"inherit"} href={"mailto:"+decodedEntity.email} underline='none'>{decodedEntity.email}</Link>  
                </Typography>
            </div>}
            {decodedEntity.phone && <div className='dis-flex flex-row'>
                <CallIcon />
                <Typography className='p-l-6'>
                    <Link color={"inherit"} href={"tel:"+decodedEntity.phone} underline='none'>{decodedEntity.phone}</Link>
                </Typography>
            </div>}
            {decodedEntity.website && <div className='dis-flex flex-row'>
                <WebIcon />
                <Typography className='p-l-6'>
                    <Link color={"inherit"} href={decodedEntity.website} target="_blank" rel="noopener noreferrer" underline='none'>{decodedEntity.website}</Link>
                </Typography>
            </div>}
        </div>
    )
}

export default GetStartedComponent;